import type { SVGAttributes } from "react";
import "./icon.css";

// Icone in linea, le stesse dei mock-up (nessuna libreria): tratto da 2 px su una griglia da 24.
// Sono decorazione: il significato sta sempre nel testo accanto, quindi `aria-hidden`.
const paths = {
  check: <path d="M5 12l5 5 9-10" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v4l3 2" />
    </>
  ),
  minus: <path d="M6 12h12" />,
  lock: (
    <>
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 018 0v3" />
    </>
  ),
  alert: (
    <>
      <path d="M12 4l9 16H3z" />
      <path d="M12 10v4M12 17v.5" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8v.5" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6L6 18" />,
  // «Ascolta» e «Pausa» del riproduttore delle registrazioni (piano M4, Task 12), le stesse dei mock-up.
  play: <path d="M7 5l12 7-12 7z" />,
  pause: <path d="M9 5v14M15 5v14" />,
  // Rail dell'applicazione (Task 5): le stesse dei mock-up; «building» per le aziende è nuova.
  home: (
    <>
      <path d="M3 11l9-7 9 7" />
      <path d="M5 10v10h14V10" />
      <path d="M10 20v-6h4v6" />
    </>
  ),
  // La voce «Task» della rail (piano M5, Task 18), la stessa del mock-up: un quadrato con la spunta.
  task: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M8 12l3 3 5-6" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
    </>
  ),
  building: (
    <>
      <rect x="5" y="3" width="14" height="18" rx="1" />
      <path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01M10 21v-3h4v3" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  // Team (Task 7): «Invita una persona», come nel mock-up.
  plus: <path d="M12 5v14M5 12h14" />,
  // Calendario (Task 10): «Togli la chiusura», come nel mock-up.
  trash: <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" />,
  // Elenco Lead (piano M2 Task 17): la voce della rail, la ricerca, le icone delle colonne e le frecce
  // dell'ordinamento, come nel mock-up.
  lead: (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <path d="M16 4.5a3.5 3.5 0 010 7" />
      <path d="M18 14c2 .8 3 2.9 3 6" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="M20 20l-4.5-4.5" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s-7-6.5-7-12a7 7 0 0114 0c0 5.5-7 12-7 12z" />
      <circle cx="12" cy="9" r="2.5" />
    </>
  ),
  dot: <circle cx="12" cy="12" r="3" />,
  phone: <path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" />,
  // «Chiudi la chiamata» della postazione (piano M4, Task 13), come nel mock-up.
  hangup: <path d="M3 15c5-5 13-5 18 0l-2 3-4-1.5V14a10 10 0 00-6 0v2.5L5 18z" />,
  // Il microfono in uso nella testata della postazione (richiesta del product owner del 6 ottobre 2026): nuova, nessun mock-up.
  microphone: (
    <>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0014 0M12 18v3M8 21h8" />
    </>
  ),
  report: <path d="M5 20V10M12 20V4M19 20v-7" />,
  tag: (
    <>
      <path d="M3 12V4h8l10 10-8 8z" />
      <circle cx="7.5" cy="8.5" r="1" />
    </>
  ),
  calendar: (
    <>
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M4 10h16M9 3v4M15 3v4" />
    </>
  ),
  note: (
    <>
      <path d="M4 20h4L19 9l-4-4L4 16z" />
      <path d="M13 7l4 4" />
    </>
  ),
  up: <path d="M12 19V5M6 11l6-6 6 6" />,
  down: <path d="M12 5v14M6 13l6 6 6-6" />,
  // Il pulsante «Filtri» dell'elenco Lead (piano M3 Task 4), come nel mock-up.
  filter: <path d="M4 5h16l-6 8v5l-4 2v-7z" />,
  // La Vista Commerciale (piano M2 Task 22): guardare, non agire al posto di.
  eye: (
    <>
      <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  // «Colonne e vista» e le intestazioni dell'elenco Lead (piano M3 Task 6): «columns», «left» e «right» come nel
  // mock-up; «more» (i tre punti del menu «…») con il tratto di «grip».
  columns: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9.5 4v16M14.5 4v16" />
    </>
  ),
  left: <path d="M19 12H5M11 6l-6 6 6 6" />,
  right: <path d="M5 12h14M13 6l6 6-6 6" />,
  more: <path d="M6 12h.01M12 12h.01M18 12h.01" />,
  // Smart List (piano M3 Task 8): la voce della rail, come nel mock-up.
  smartlist: <path d="M4 6h16M7 12h10M10 18h4" />,
  // «Conversazioni» (piano M4, Task 19): la voce della rail, come nel mock-up.
  conversations: <path d="M4 5h16v11H9l-5 4z" />,
  // «Opportunità» (piano M6, R8, Task 25): la voce della rail, come nel mock-up.
  opportunity: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="1" />
    </>
  ),
  // «Opportunità» in testata e «Apri l'opportunità» nel riquadro della scheda (LEAD-2), come nel mock-up.
  briefcase: (
    <>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M9 7V5h6v2" />
    </>
  ),
  // «Riduci il menu» e «Allarga il menu» in fondo alla rail (riscontro del product owner del 3 ottobre 2026).
  collapse: <path d="M11 17l-5-5 5-5M18 17l-5-5 5-5" />,
  expand: <path d="M13 17l5-5-5-5M6 17l5-5-5-5" />,
  // La barra del Power Dialer (piano M5, Task 5): «Salta» e «Interrompi», come nel mock-up; «Pausa» e «Riprendi» usano
  // `pause` e `play` del riproduttore qui sopra.
  skip: (
    <>
      <path d="M5 5l10 7-10 7z" />
      <path d="M19 5v14" />
    </>
  ),
  stop: <rect x="6" y="6" width="12" height="12" rx="1" />,
  // Gli eventi delle email di GoHighLevel nella Timeline (ingresso dei Lead, I5): una busta.
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </>
  ),
  // «WhatsApp» nella testata, nella sua finestra e nella Timeline (piano M6, R1, Task 4a), come nel mock-up.
  whatsapp: <path d="M20 12a8 8 0 01-11.8 7L4 20l1-4A8 8 0 1120 12z" />,
  // La puntina di «Fissa in alto» nel menu delle Smart List (SL-11): una puntina da bacheca, non il segnaposto di `pin`.
  pushpin: (
    <>
      <path d="M9 3h6M10 3v6l-3 4h10l-3-4V3" />
      <path d="M12 13v8" />
    </>
  ),
  // «Pulizia dati» nell'elenco Lead (piano M3 Task 18), come nel mock-up.
  wand: (
    <>
      <path d="M4 20L14 10" />
      <path d="M15 4v3M18.5 5.5l-2 2M20 9h-3M13 7.5l3 3" />
    </>
  ),
} as const;

export type IconName = keyof typeof paths;

type Props = Omit<SVGAttributes<SVGSVGElement>, "children"> & {
  name: IconName;
  size?: "sm" | "md";
};

export function Icon({ name, size = "sm", className, ...rest }: Props) {
  const classes = className ? `g-icon ${className}` : "g-icon";
  return (
    <svg className={classes} data-size={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...rest}>
      {paths[name]}
    </svg>
  );
}
